<template>
  <base-hover v-slot="{ isHover }">
    <div
      class="product-item"
      :style="[{
        'background-color': user.profile.institution.color
      } ]"
    >
      <div class="product-container">
        <img
          v-srcset
          :src="img"
          alt=""
          class="product-item__image"
          :style="maxWidth"
        >
        <div
          v-if="!editMode"
          class="product-item__content"
          @dblclick="startEditing"
        >
          <p
            v-if="showBrandName"
            class="product-item__description"
          >
            {{ description || 'Add brand name' }}
          </p>
          <h3 class="product-item__title">
            {{ title || 'Add description' }}
          </h3>
        </div>
        <div
          v-else
          class="product-item__content"
        >
          <p class="product-item__description">
            <template v-if="editable">
              <input
                ref="input1"
                v-model.trim="newDescription"
                type="text"
                class="ml-1 inputs form-control"
                placeholder="Add brand name"
                @keypress.enter="stopEditing"
                @blur="onBlur"
                @focus="isFocused = true"
              >
            </template>
            <template v-else-if="showBrandName">
              {{ description || 'Add brand name' }}
            </template>
          </p>
          <h3 class="product-item__title">
            <input
              ref="input2"
              v-model.trim="newTitle"
              type="text"
              class="ml-1 inputs form-control"
              placeholder="Add description"
              style="margin-top: 4px;"
              @keypress.enter="stopEditing"
              @blur="onBlur"
              @focus="isFocused = true"
            >
          </h3>
          <h3 class="product-item__title">
            <input
              ref="input3"
              v-model.trim="newURL"
              type="text"
              class="ml-1 inputs form-control"
              placeholder="Add URL"
              style="margin-top: 4px;"
              @keypress.enter="stopEditing"
              @blur="onBlur"
              @focus="isFocused = true"
            >
          </h3>
        </div>
        <template v-if="(isHover || isIPad) && canDelete">
          <base-icon
            v-if="!useFeature('product_edit_enabled')"
            class="product-item__button-close"
            icon="widget-close"
            @click="$emit('close')"
          />
          <div v-else class="icon-container-wrapper">
            <div class="icon-container">
              <div
                class="icon-wrapper-left"
                :class="{ 'hover-bg': hoverPen }"
                @click="startEditing()"
                @mousedown="hoverPen = true"
                @mouseup="hoverPen = false"
              >
                <font-awesome-icon icon="pen" class="fa-lg" />
              </div>

              <div
                class="icon-wrapper-right"
                :class="{ 'hover-bg': hoverTrash }"
                @click="$emit('close')"
                @mousedown="hoverTrash = true"
                @mouseup="hoverTrash = false"
              >
                <font-awesome-icon icon="trash" class="fa-lg" />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </base-hover>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';
import whichbrowser from '@/components/mixins/whichbrowser';

export default {
  name: 'ProductItem',
  mixins: [utilsMixin, whichbrowser],
  props: {
    pk: {
      type: Number,
      required: false,
      default: 0,
    },
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
    url: {
      type: String,
      required: false,
      default: '',
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    productRowWidth: {
      type: Number,
      default: -1,
    },
  },
  data() {
    return {
      editMode: false,
      hoverPen: false,
      hoverTrash: false,
      isFocused: false,
      newDescription: '',
      newTitle: '',
      newURL: '',
    };
  },
  computed: {
    user() {
      return this.$store.state.account.user;
    },
    showBrandName() {
      return this.$store.getters['account/theme'].product_display_brand;
    },
    maxWidth() {
      if (this.productRowWidth === 3) {
        return { width: '220px', height: '293px' };
      } else if (this.productRowWidth === 2) {
        return { width: '352px', height: '469px' };
      } else if (this.productRowWidth === 1) {
        return { width: '450px', height: '600px' };
      }
      return '';
    },
  },
  watch: {
    description: {
      immediate: true,
      handler(newVal) {
        this.newDescription = newVal;
      },
    },
    title: {
      immediate: true,
      handler(newVal) {
        this.newTitle = newVal;
      },
    },
    url: {
      immediate: true,
      handler(newVal) {
        this.newURL = newVal;
      },
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false;
      setTimeout(() => {
        if (!this.isFocused) {
          this.stopEditing();
        }
      }, 100);
    },
    startEditing() {
      if (!this.useFeature('product_edit_enabled')) {
        return;
      }

      this.editMode = true;
      this.$nextTick().then(() => {
        if (this.editable) {
          this.$refs.input1.focus();
        } else {
          this.$refs.input2.focus();
        }
      });
    },
    stopEditing() {
      this.editMode = false;
      const canSendUpdate = true;// (this.isFocused === this.editMode); // This prevents double updating
      if (canSendUpdate) {
        this.$emit('edit', {
          pk: this.pk, description: this.newDescription, title: this.newTitle, site_url: this.newURL,
        });
      }
    },
  },
};
</script>

<style lang="scss">
// @import "../styles/main.scss";
  .inputs{
    border-radius: 3px;
    height: 28px;
    width: 100%;
  }
  .inputs:focus{
    outline: solid 2px #ABABAB;
    box-shadow: 0px 0px 0px 3px rgba(51, 51, 51, 0.12);
    border-color: #ABABAB !important;
  }
  .icon-container-wrapper{
    position: absolute;
    right: 0;
    top: -66px;
    width: 80px;
    height: 66px;
  }

  .icon-container {
    position: absolute;
    width: 80px;
    height: 60px;
    background-color: #FAF9F7;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.15);
  }

  .icon-wrapper {
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    border-radius: 8px;

  }
  .icon-wrapper-left {
    @extend .icon-wrapper;
    border-radius: 8px 0 0 8px;
  }

  .icon-wrapper-right {
    @extend .icon-wrapper;
    border-radius: 0 8px 8px 0;
  }

  .product-container {
    padding: 0;
    display: flex;
    flex-direction: column;
    //width: fit-content;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    &:hover {
      outline: dashed 1px black; // Adjust color as needed
      box-shadow: 0px 0px 4px rgba(51, 51, 51, 0.2); // Optional for a subtle effect
    }
  }

  .product-item{
    position: relative;
    text-align: center;
    background-color: white;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    &{
      padding: 0;
      // background: $bg-product;
      // min-width: 200px;
    }
    &__image{
      width: 100%;
      height: 100%;
      pointer-events: none;
      object-fit: cover;
    }
    &__title{
      font-size: 0.75rem;
      margin-bottom: 0;
      color: $gray-600;
      display: flex;
      justify-content: center;
    }
    &__description{
      // font-weight: bold;
      font-family: $font-family-sans-serif-medium;
      font-size: 0.75rem;
      margin-bottom: 0;
      display: flex;
      justify-content: center;
    }
    &__content{
      padding: 0.75rem;
      text-align: center;
    }
    &__content:hover{
      cursor: auto;
    }
    &__pen-icon{
      background-color: #f2f2f2;
      border-radius: 3px;
      position: absolute;
      top: 50%;
      left: 50%;
      padding: 20px 30px;
      font-size: 36px;
      transform: translate(-50%, -50%);
      opacity: 0;
      transition: all 0.2s;
    }
    &__button-close{
      position: absolute;
      top: 6px;
      right: 0;
      border-radius: 20px;
      padding: 3px 10px;
      transition: all 0.2s;

    }
    &:hover &__pen-icon{
      opacity: 1;
    }

    .hover-bg {
      background-color: #F2F1EE;
    }

}
</style>
